// extracted by mini-css-extract-plugin
export default {"notAvaliable":"NotAvaliable_notAvaliable__wnW6M"};